import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { UNIFIED_APP_LINK } from '@shared/contants'
import QrCode from '@shared/ui/qrcode/QrCode'


import styles from './styles.module.scss'

export default function AppLink () {
  const { t: tc } = useTranslation('common')
  const isTabletMq = useMediaQuery('(max-width: 1023px)')

  if (isTabletMq) {
    return null
  }

  return (
    <div className={styles.root}>
      <div className={styles.root__qr}>
        <QrCode
          value={UNIFIED_APP_LINK}
          size={180}
          className={styles.root__qrCode}
        />
        <p
          className={styles.root__desc}
          dangerouslySetInnerHTML={{
            __html: tc('app.qr.description'),
          }}
        ></p>
      </div>
    </div>
  )
}
